<template>
  <div class="resume-library-page">
    <PageHeaderLayout :isBack="true">
      <div class="main-page-content">
        <div class="layout-card">
          <div class="side-panel">
            <el-scrollbar class="tree-scrollbar">
              <div
                v-for="(item, index) in state.treeData"
                :key="item.id || index"
                class="tree-node"
              >
                <div class="tree-parent" @click="item.isSpread = !item.isSpread">
                  <span class="tree-parent-left">
                    <span class="tree-parent-title">{{ item.label }}</span>
                    <span class="tree-parent-count">（{{ item.num }}）</span>
                  </span>
                  <span class="tree-parent-right">
                    <i
                      v-if="index !== 0"
                      class="el-icon-plus action-icon action-icon-primary"
                      @click.stop="event_addResume(item, 'create')"
                    ></i>
                    <i
                      v-if="item.children.length !== 0"
                      :class="['el-icon-arrow-down', 'tree-arrow', item.isSpread && 'is-spread']"
                    ></i>
                  </span>
                </div>

                <div :class="['tree-child-wrap', !item.isSpread && 'is-hidden']">
                  <div
                    v-for="(child, childIndex) in item.children"
                    :key="child.id || `${item.id}-${childIndex}`"
                    :class="[
                      'tree-child',
                      state.treeActive === `${item.id}-${childIndex}` && 'active',
                    ]"
                    @click="event_selectTreeChild(item, childIndex, child)"
                  >
                    <div class="tree-child-left">
                      <span class="tree-child-icon">
                        <el-image
                          v-if="index !== 0"
                          :src="`https://img.51xinlong.com/khlmanage/hr/icon-depart-item.png`"
                        />
                        <el-image
                          v-else
                          :src="`https://img.51xinlong.com/khlmanage/hr/icon-sys-status${childIndex + 1}.png`"
                        />
                      </span>
                      <span class="tree-child-label">{{ child.label }}</span>
                      <span class="tree-child-count">（{{ child.num }}）</span>
                    </div>
                    <div class="tree-child-right">
                      <i
                        v-if="index !== 0"
                        class="el-icon-edit action-icon"
                        :style="{
                          color:
                            state.treeActive === `${item.id}-${childIndex}` ? '#FFFFFF' : '#3370FF',
                        }"
                        @click.stop="event_addResume(child, 'edit')"
                      ></i>
                      <i
                        v-if="index !== 0"
                        class="el-icon-delete action-icon action-icon-danger"
                        @click.stop="event_addResume(child, 'delete')"
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
            </el-scrollbar>
          </div>

          <div class="content-panel">
            <div class="search-card">
              <el-form :inline="true" :model="state.searchCondition" size="medium">
                <el-form-item label="姓名">
                  <el-input
                    v-model="state.searchCondition.realname"
                    placeholder="请输入姓名"
                    clearable
                  />
                </el-form-item>
                <el-form-item label="手机号">
                  <el-input
                    v-model="state.searchCondition.mobile"
                    placeholder="请输入手机号"
                    clearable
                  />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="searchButton">查询</el-button>
                  <el-button @click="resetSearch">重置</el-button>
                </el-form-item>
              </el-form>
            </div>

            <div class="table-card">
              <ApeTable
                ref="refApeTable"
                :data="state.tableData"
                :columns="state.columns"
                :loading="state.loading"
                :pagingData="state.pagingData"
                @switchPaging="switchPaging"
                highlight-current-row
              >
                <el-table-column label="简历" header-align="center" align="center" width="120">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      size="mini"
                      @click="goResumeView(scope.row)"
                    >
                      查看简历
                    </el-button>
                  </template>
                </el-table-column>
              </ApeTable>
            </div>
          </div>
        </div>
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";

function createDefaultSearchCondition() {
  return {
    realname: "",
    mobile: "",
  };
}

function createDefaultPagingData() {
  return {
    is_show: true,
    layout: "total, sizes, prev, pager, next, jumper",
    total: 0,
    offset: 0,
  };
}

function createDefaultColumns() {
  return [
    { title: "姓名", value: "realname", header_align: "center", align: "center", width: 100 },
    { title: "性别", value: "sex_text", header_align: "center", align: "center", width: 80 },
    { title: "年龄", value: "age_text", header_align: "center", align: "center", width: 80 },
    { title: "最高学历", value: "best_education_text", header_align: "center", align: "center", width: 120 },
    { title: "手机号", value: "mobile", header_align: "center", align: "center", width: 140 },
    { title: "岗位名称", value: "recruit_post_text", header_align: "center", align: "center", width: 180 },
    { title: "报名时间", value: "created_at", header_align: "center", align: "center", width: 180 },
  ];
}

function createDefaultState() {
  return {
    actionResumePid: "",
    loading: false,
    treeActive: "626-0",
    tableData: [],
    columns: createDefaultColumns(),
    pagingData: createDefaultPagingData(),
    baseSearch: {
      resume_status: 1,
    },
    searchCondition: createDefaultSearchCondition(),
    treeDataSys: [
      {
        label: "系统简历库",
        num: 0,
        isSpread: true,
        id: "626",
        children: [
          { label: "待处理", num: 0, resume_status: 1 },
          { label: "已邀约", num: 0, resume_status: 2 },
          { label: "面试未通过", num: 0, resume_status: 3 },
          { label: "面试通过", num: 0, resume_status: 4 },
          { label: "在职", num: 0, resume_status: 5 },
          { label: "暂不符合", num: 0, resume_status: 7 },
        ],
      },
    ],
    treeData: [],
    dialog: {
      addResume: {
        action: "",
        title: "新增",
        show: false,
        showParent: false,
        nameLabel: "简历库名称",
        form: {
          group_name: "",
          label: "",
        },
      },
    },
  };
}

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
  },
  data() {
    return {
      state: createDefaultState(),
    };
  },
  methods: {
    getSexTextByIdCard(item) {
      const idCard = String(item.idcard || item.id_number || item.id_card || "").trim();

      if (idCard.length === 18) {
        const sexFlag = Number(idCard.charAt(16));
        if (!Number.isNaN(sexFlag)) {
          return sexFlag % 2 === 1 ? "男" : "女";
        }
      }

      if (idCard.length === 15) {
        const sexFlag = Number(idCard.charAt(14));
        if (!Number.isNaN(sexFlag)) {
          return sexFlag % 2 === 1 ? "男" : "女";
        }
      }

      if (item.sex === 1 || item.sex === "1") {
        return "男";
      }
      if (item.sex === 2 || item.sex === "2") {
        return "女";
      }

      return "-";
    },
    normalizeTableData(list = []) {
      return list.map((item) => ({
        ...item,
        sex_text: this.getSexTextByIdCard(item),
        age_text: item.age && item.age !== "-" ? `${item.age}岁` : "-",
        recruit_post_text:
          item.ph_hr_recruit_task && item.ph_hr_recruit_task.recruit_post
            ? item.ph_hr_recruit_task.recruit_post
            : "-",
        best_education_text: item.best_education_text || "-",
        mobile: item.mobile || "-",
        created_at: item.created_at || "-",
      }));
    },
    buildSearchParams() {
      const params = {
        ...this.state.baseSearch,
      };

      if (this.state.searchCondition.realname) {
        params.realname = this.state.searchCondition.realname;
      }
      if (this.state.searchCondition.mobile) {
        params.mobile = this.state.searchCondition.mobile;
      }
      return params;
    },
    async init(type = "") {
      if (!this.$refs.refApeTable) {
        return;
      }

      if (type === "search" && this.$refs.refApeTable.setCurrentChange) {
        this.$refs.refApeTable.setCurrentChange(1);
      }

      this.state.loading = true;
      try {
        const pagingInfo = this.$refs.refApeTable.getPagingInfo(type || "no_del");
        if (type === "search") {
          pagingInfo.current_page = 1;
        }

        const res = await this.$api.employeeList({
          ...this.buildSearchParams(),
          ...pagingInfo,
        });

        this.state.tableData = this.normalizeTableData(res.data || []);
        this.state.pagingData = {
          ...this.state.pagingData,
          ...(res.pages || {}),
        };
      } finally {
        this.state.loading = false;
      }
    },
    searchButton() {
      this.init("search");
    },
    resetSearch() {
      this.state.searchCondition = createDefaultSearchCondition();
      this.init("search");
    },
    switchPaging() {
      this.init();
    },
    goResumeView(row) {
      const mobile = row.mobile && row.mobile !== "-" ? row.mobile : "";
      const id_number = row.id_number || row.idcard || "";
      if (!mobile && !id_number) {
        this.$message.warning("缺少手机号或身份证号，无法查看简历");
        return;
      }
      this.$router.push({
        path: "/candidate/resumeView",
        query: {
          mobile,
          id_number,
        },
      });
    },
    async event_confirm_addResume() {
      if (!this.state.dialog.addResume.form.group_name) {
        this.$message.warning(`请输入${this.state.dialog.addResume.nameLabel}`);
        return;
      }

      if (this.state.dialog.addResume.action === "create") {
        const params = {
          group_name: this.state.dialog.addResume.form.group_name,
          group_type: 3,
        };
        if (this.state.actionResumePid) {
          params.pid = this.state.actionResumePid;
        }
        await this.$api.createHrDepartmentGroup(params);
      }

      if (this.state.dialog.addResume.action === "edit") {
        await this.$api.saveHrDepartmentGroupName(this.state.actionResumePid, {
          group_name: this.state.dialog.addResume.form.group_name,
        });
      }

      this.$message.success("操作成功");
      this.state.dialog.addResume.show = false;
      await this.getResumeList();
      // await this.getGroupList();
      await this.init();
    },
    event_addResume(item, type) {
      this.state.dialog.addResume.action = type;

      if (type === "delete") {
        this.$confirm("是否进行删除？", "提示", {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
        })
          .then(async () => {
            await this.$api.deleteHrDepartment(item.id);
            this.$message.success("操作成功");
            await this.getResumeList();
            await this.init();
          })
          .catch(() => {});
        return;
      }

      this.state.dialog.addResume.show = true;

      if (item) {
        this.state.actionResumePid = item.id;
        this.state.dialog.addResume.form = {
          group_name: type === "edit" ? item.label : "",
          label: item.label || "",
        };
        this.state.dialog.addResume.showParent = type === "create";
        this.state.dialog.addResume.nameLabel = type === "create" ? "类别名称" : "简历库名称";
        this.state.dialog.addResume.title = type === "create" ? "新增" : "编辑";
        return;
      }

      this.state.actionResumePid = "";
      this.state.dialog.addResume.form = {
        group_name: "",
        label: "",
      };
      this.state.dialog.addResume.showParent = false;
      this.state.dialog.addResume.nameLabel = "简历库名称";
      this.state.dialog.addResume.title = "新增";
    },
    async event_selectTreeChild(item, index, target) {
      this.state.treeActive = `${item.id}-${index}`;
      if (target.resume_status) {
        this.state.baseSearch = {
          resume_status: target.resume_status,
        };
      } else {
        this.state.baseSearch = {
          department_ids: target.id,
        };
      }
      await this.init("search");
    },
    async getResumeList() {
      const res = await this.$api.hrDepartmentList({ group_type: 3 });
      const customTree = (res.data || []).map((item) => ({
        label: item.group_name,
        num: item.all_employee_num,
        isSpread: false,
        id: item.id,
        children:
          item.recursion_list && item.recursion_list !== ""
            ? item.recursion_list.map((child) => ({
                label: child.group_name,
                num: child.all_employee_num,
                id: child.id,
              }))
            : [],
      }));

      this.state.treeData = [...this.state.treeDataSys, ...customTree];
    },
    async initData() {
      const systemCountRes = await this.$api.resumeLibrarySystemCount();
      const {
        all_count,
        inconsistent_count,
        interview_not_pass_count,
        interview_pass_count,
        invited_count,
        on_the_job_count,
        pending_count,
      } = systemCountRes;

      this.state.treeDataSys[0].num = all_count;
      this.state.treeDataSys[0].children[0].num = pending_count;
      this.state.treeDataSys[0].children[1].num = invited_count;
      this.state.treeDataSys[0].children[2].num = interview_not_pass_count;
      this.state.treeDataSys[0].children[3].num = interview_pass_count;
      this.state.treeDataSys[0].children[4].num = on_the_job_count;
      this.state.treeDataSys[0].children[5].num = inconsistent_count;

      await this.getResumeList();
    },
  },
  async mounted() {
    await this.initData();
    await this.init("search");
  },
};
</script>

<style lang="scss" scoped>
.resume-library-page {
  :deep(.el-form-item) {
    margin-bottom: 12px;
  }
}

.main-page-content {
  height: calc(100vh - 260px);
}

.layout-card {
  display: flex;
  height: 100%;
  background: transparent;
}

.side-panel {
  width: 250px;
  height: 100%;
  background: #f6f7f9;
  margin-right: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.tree-scrollbar {
  flex: 1;
}

.tree-node {
  width: 100%;
}

.tree-parent {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 56px;
  padding: 0 24px;
  cursor: pointer;
  box-sizing: border-box;
}

.tree-parent-left,
.tree-child-left,
.tree-parent-right,
.tree-child-right {
  display: flex;
  align-items: center;
}

.tree-parent-title {
  font-size: 14px;
  font-weight: 600;
  color: #364056;
}

.tree-parent-count,
.tree-child-count {
  font-size: 12px;
  color: #7d8593;
}

.tree-child-wrap {
  overflow: hidden;
  transition: all 0.3s ease;

  &.is-hidden {
    height: 0 !important;
  }
}

.tree-child {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 48px;
  padding: 0 24px 0 28px;
  cursor: pointer;
  box-sizing: border-box;
  transition: all 0.3s ease;

  &:hover {
    background: #1890ff;

    .tree-child-label,
    .tree-child-count {
      color: #ffffff;
    }

    .tree-child-right :deep(svg) {
      color: #ffffff;
    }

    .tree-child-icon {
      filter: brightness(100);
    }
  }

  &.active {
    background: #1890ff;

    .tree-child-label,
    .tree-child-count {
      color: #ffffff;
    }

    .tree-child-icon {
      filter: brightness(100);
    }
  }

  &.disabled:hover {
    background: transparent;
  }
}

.tree-child-icon {
  width: 16px;
  height: 16px;
  margin-right: 10px;
  border-radius: 50%;
  overflow: hidden;
  display: inline-flex;
}

.tree-child-label {
  font-size: 13px;
  color: #364056;
}

.tree-arrow {
  color: #9699ab;
  transition: all 0.3s ease;

  &.is-spread {
    transform: rotate(180deg);
  }

  &.is-opacity {
    opacity: 0;
  }
}

.action-icon {
  margin-left: 8px;
  font-size: 18px;
  cursor: pointer;
}

.action-icon-primary {
  color: #3370ff;
}

.action-icon-danger {
  color: #f84a4a;
}

.content-panel {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.search-card {
  padding: 0 0 8px;
  background: #ffffff;
}

.table-card {
  flex: 1;
  min-height: 0;
  padding: 0;
  background: #ffffff;
}

.selected-person {
  margin-bottom: 16px;
  color: #364056;
}

:deep(.el-table .cell) {
  word-break: break-word;
}
</style>
